import React from 'react';
import * as R from 'ramda';

import ApprovalCheckmark from 'js/components/approval_checkmark';
import DisapprovalXMark from 'js/components/disapproval_x_mark';
import FadingScroll from 'js/components/fading_scroll';

import './index.scss';

function guideline({id, should, guideline}) {
    const Icon = should ? ApprovalCheckmark : DisapprovalXMark;
    return (
        <div key={id} className="guidelines-checklist__guideline">
            <div className="guidelines-checklist__icon">
                <Icon inverted />
            </div>
            {guideline}
        </div>
    );
}

export default function GuidelinesChecklist({guidelines}) {
    return (
        <div className="guidelines-checklist">
            <FadingScroll>{R.map(guideline, guidelines)}</FadingScroll>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/guidelines_checklist/index.js